(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lf-quiz-rewards"] && !Shopify.designMode) return;
  try {
    function initRewardCollection(){
  document.querySelectorAll('[data-rewards]').forEach(root=>{
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const params=new URLSearchParams(window.location.search);
    const rawCode=params.get('reward')||'';
    const code=/^[A-Za-z0-9_-]{4,80}$/.test(rawCode)?rawCode:'';
    const enabled=root.dataset.launch==='true';
    const cards=Array.from(root.querySelectorAll('.lfr-card'));
    const note=root.querySelector('[data-link-note]');
    if(enabled&&!code)note.hidden=false;
    const updateCard=card=>{
      const select=card.querySelector('select[data-variant]');
      if(select){
        const option=select.selectedOptions[0];
        card.querySelector('[data-original]').textContent=option.dataset.price;
      }
    };
    cards.forEach(card=>{
      const select=card.querySelector('select[data-variant]');
      if(select)select.addEventListener('change',()=>updateCard(card));
      const button=card.querySelector('[data-claim]');
      if(enabled&&code){button.disabled=false;button.textContent=button.dataset.readyText;}
      button.addEventListener('click',()=>{
        if(!enabled||!code)return;
        const id=card.querySelector('[data-variant]').value;
        if(!/^\d+$/.test(id))return;
        window.location.assign(root.dataset.cartRoot+id+':1?discount='+encodeURIComponent(code));
      });
    });

  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initRewardCollection);}else{initRewardCollection();}
document.addEventListener('shopify:section:load',initRewardCollection);
  } catch(e) { console.error(e); }
})();

})();
